import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { AdvanceSearchService } from '../../../services/Advance-search/advance-search.service';
import { ToastService } from '../../../services/toast/toast.service';

@Component({
  selector: 'app-manual-edit-status',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './manual-edit-status.component.html',
  styleUrl: './manual-edit-status.component.scss'
})
export class ManualEditStatusComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ManualEditStatusComponent>,
    private advanceSearch: AdvanceSearchService,
    private toaster: ToastService,
  ) {}

  close(): void {

    this.dialogRef.close();

  }

  continue(): void {

    const payLoad = {

      devoteeId:
        this.data.devoteeId,

      status:
        this.data.status

    };

    this.advanceSearch.UpdateManualStatus(payLoad).subscribe({

      next: (res: any) => {

        this.toaster.success(
          `Status changed to ${this.data.status}`
        );

        this.dialogRef.close(true);

      },

      error: (err: any) => {

        this.toaster.error(
          err?.error?.message || 'Something went wrong'
        );

      }

    });

  }

}